// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-iconOnly-button-be4e30c5","buttonIcon":"skins-iconOnly-buttonIcon-18b6676e"};